import SubRouteMenu from "./SubRouteMenu.presenter";

export default SubRouteMenu;
